<template>
    <button class="cart-icon-container" @click.stop="visitCart">
        <span v-if="cartProductsCount && cartProductsCount > 0" class="count">
            {{ cartProductsCount }}
        </span>
        <svg class="cart-icon" viewBox="0 0 20 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Header---Style-Guide" transform="translate(-125.000000, -425.000000)" fill="#000000" fill-rule="nonzero">
                    <path d="M144.333333,431.974425 L140.166667,431.974425 L140.166667,430.558824 C140.166667,427.485934 137.833333,425 135,425 C132.166667,425 129.833333,427.485934 129.833333,430.558824 L129.833333,431.974425 L125.666667,431.974425 C125.3,431.974425 125,432.285166 125,432.664962 L125,449.928389 C125,451.067775 125.9,452 127,452 L143,452 C144.1,452 145,451.067775 145,449.928389 L145,432.664962 C145,432.285166 144.7,431.974425 144.333333,431.974425 Z M131.5,430.558824 C131.5,428.452685 133.066667,426.726343 135,426.726343 C136.933333,426.726343 138.5,428.452685 138.5,430.558824 L138.5,431.974425 L131.5,431.974425 L131.5,430.558824 Z" id="Shape"></path>
                </g>
            </g>
        </svg>
    </button>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                headerStyle: 'menu/headerStyle',
                cartProductsCount: 'cart/cartProductsCount'
            }),
        },
        methods:{
          visitCart(){
              this.$router.push({path:'/cart'});
          }
        },
        mixins: [Mixins]
    }
</script>

<style lang="scss" scoped>
    .cart-icon-container {
        position: relative;
        width: 23px;
        height: 33px;
        top: 1px;

        .count {
            position: absolute;
            top: calc(50% - 1px);
        }
        .cart-icon {
            width: 23px;
            height: 35px;
            path {
                &.background {
                    fill: #000;
                }
                &.outline {
                    fill: #fff;
                }
            }
        }
    }
</style>